import controller from './merchantTermsModal.controller';
import template from './merchantTermsModal.html';

const merchantTermsModalComponent = {
  restrict: 'E',
  bindings: {
    termini: '<',
    onClose: '&'
  },
  template,
  controller
};

export default merchantTermsModalComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/merchantTermsModal/merchantTermsModal.component.js
 **/